"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogout = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
const UserContext_1 = require("../UserContext");
function useLogout() {
    const { setUser } = (0, UserContext_1.useUserContext)();
    const { isLoading, error, post } = (0, core_ui_1.useApiPost)('users/logout');
    // useEffect(() => {
    //   if (response && response.ok) {
    //     console.log('user logged out', response.ok);
    //     api.removeAccessToken();
    //     setUser(null);
    //   }
    // }, [response, setUser]);
    const doLogout = (0, react_1.useCallback)(() => {
        post();
        // NOTE: logout endpoint doesn't return anything so above
        // useEffect() won't work
        core_ui_1.api.removeAccessToken();
        setUser(null);
    }, [post, setUser]);
    return { isLoading, error, doLogout };
}
exports.useLogout = useLogout;
//# sourceMappingURL=useLogout.js.map